import { classNames } from "@/utility/jsx";
import { t } from "@lingui/core/macro";
import React from "react";
import { GeoJSONFilesTable } from "./GeoJSONFilesTable";
import styles from "./style.module.scss";

export function GeoJSONUploadedFilesSection() {
  return (
    <div className={classNames(styles.geojson__section, styles["geojson__uploaded-files"])}>
      <div className={styles.geojson__heading}>{t`Your uploaded files`}</div>
      <GeoJSONFilesTable />
    </div>
  );
}
